import fetchEstimates from '../../../Services/fetchEstimates'

export default () => (dispatch) => {

  dispatch(fetchEstimates())

}
